/**
 * Internal dependencies
 */
import WMUWCAccount from './account';

/**
 * 
 */
const account = new WMUWCAccount( {
	actionLogin: wmuwcAccountArgs.actionLogin,
	actionLogout: wmuwcAccountArgs.actionLogout,
	actionLostPassword: wmuwcAccountArgs.actionLostPassword,
	ajaxUrl: wmuwcAccountArgs.ajaxUrl,
	nonce: wmuwcAccountArgs.nonce,
	debug: wmuwcAccountArgs.debug,
} );

/**
 * 
 */
document.addEventListener( 'DOMContentLoaded', ( event ) =>
{
	account.initLoginButtons();
	account.initLogoutButtons();
	account.initLostPasswordButtons();

	/**
	 * Debug / Dev
	 */
	// account.login();
} );